module.exports = __webpack_public_path__ + "img/icon_pdf.1e80df03.svg";